import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../../providers/navigation.service';
import { ITableColumnHeader } from '../../../models/table-column-header';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../providers/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SM_CONSTANTS } from '../../../shared/constants/sm-constants';
import { environment } from '../../../../environments/environment.prod';
import { MatDialog } from '@angular/material/dialog';
import { CancelVerificationComponent } from './cancel-verification/cancel-verification.component';
import { StorageService } from 'src/app/providers/storage.service';
import { SharedService } from '../../../providers/shared.service';
import { AddDocumentsComponent } from 'src/app/shared/components/add-documents/add-documents.component';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { ViewDocumentsDetailsComponent } from 'src/app/shared/components/view-documents-details/view-documents-details.component';
import { CustomConfirmDialogComponent } from 'src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { MessagingService } from 'src/app/providers/messaging.service';
import { YoutubeEmbedVideoComponent } from '../../new-v2-pages/new-v2-component/youtube-embed-video/youtube-embed-video.component';



@Component({
  selector: 'sm-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss']
})
export class DocumentsComponent implements OnInit {
  entityHashId: string = '';
  public loader: boolean = false;
  clickEventSubscription: Subscription;
  messageList: any[] = [];
  // imageThumbUrl: string = environment.businessImageThumbBaseUrl;
  tableDisplayColumns: ITableColumnHeader[] = [
    
    {
      columnName: "name",
      columnProperty: "documentName"
    },
    {
      columnName: "description",
      columnProperty: "documentDescription"
    },
    {
      columnName: "upload date",
      columnProperty: "creationDate"
    },
    {
      columnName: "verification status",
      columnProperty: "verificationStat"
    },
    {
      columnName: "notes",
      columnProperty: "verificationNotes"
    },
  ];
  private _apiSubscription: Subscription = new Subscription();

  constructor(private sharedService: SharedService, private _apiService: ApiService,private storageService : StorageService, private dialog: MatDialog, private _navService: NavigationService, private router: Router, private route: ActivatedRoute, private loaderservice: LoaderServiceService, private messagingService: MessagingService, 
    private angularFireMessaging: AngularFireMessaging,) { 
    this._navService.hideSidebarAndNav = false;
    this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
      this.ngOnInit();
    })
  
    if(!localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == 'null'){
      this.messagingService.requestPermission();
    }
  }

  ngOnInit(): void {
    
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash

      
    })
    console.log(this.entityHashId);
    this.loader = true
    this.loaderservice.showLoader = true
    this._apiService.getBusinessDocs(this.entityHashId)

    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.GET_BUSINESS_DOCS_LIST_RESULT){
        console.log(resData);
        this.messageList = resData.result ? resData.result : [];
        this.messageList.forEach((element:any) => {
          if(element.verificationStatus == 0){
            element.verificationStat = 'Cancelled'
          }if(element.verificationStatus == 1){
            element.verificationStat = 'Verified'
          }if(element.verificationStatus == 2){
            element.verificationStat = 'Verification In progress'
          }if(element.verificationStatus == 3){
            element.verificationStat = 'Unverified'
          }
        })
        this.loaderservice.showLoader = false
        
      }
      if (resData.responseType === SM_CONSTANTS.UPDATE_BUSINESS_DOCS_STATUS_RESULT) {
        if (resData.result) {
          this.loader = true
          this._apiService.getBusinessDocs(this.entityHashId)
        } 
      }
      this.loader = false
    });

  }
  createNotification(title:any, text:any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

  // test(row:any){
  //   console.log(row);
    
  // }
test(){
  console.log("clicked");
  // this.router.navigate(['/businesses','documents'])
}

cancelVerification(rowvalue:any){
  // console.log(rowvalue);
  
  this.storageService.setValueInAppStorage('toCancelDocId', rowvalue.hashId)

  let dialogRef = this.dialog.open(CancelVerificationComponent, {
    height: '350px',
    disableClose: true,
  });
  // this.storageService.getValueFromAppStorage('toCancelDocId')
}
approveVerification(rowvalue:any){
  let data = {
    hashId: rowvalue.hashId ,
    verificationStatus: 1,
    verificationNotes: 'Verification successful'
  }
  this._apiService.updateBusinessDocsStatus(data);

  setTimeout(() => {
  this.ngOnInit();
  }, 2000);

}
progressVerification(rowvalue:any){
  let data = {
    hashId: rowvalue.hashId ,
    verificationStatus: 2,
    verificationNotes: 'Verification in-progress'
  }
  this._apiService.updateBusinessDocsStatus(data);

  setTimeout(() => {
  this.ngOnInit();
  }, 2000);
}

onAddDocument(){
  
  this.dialog.open(AddDocumentsComponent, {
      width: '700px',
      data: {
        title: 'Add Document',
        ref: this.dialog,
        data: this.entityHashId
      },
    });
}
editDocument(rowvalue:any){

  this.dialog.open(AddDocumentsComponent, {
      width: '700px',
      data: {
        title: 'Edit Document',
        ref: this.dialog,
        data: rowvalue
      },
    });
}
deleteDocument(rowvalue:any){

  // if(confirm("Are you sure you want to delete this document?")){
  //   let data = {
  //     hashId: rowvalue.hashId,
  //     status: 0
  //   }
  //   this.loaderservice.showLoader = true
  //   this._apiService.updateBusinessDocsStatus(data)
  // }

  const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
    data : {
      title : 'Alert',
      message : 'Are you sure you want to delete this document?',
      okbtn : 'Yes',
      cancelbtn : 'No',
      type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
    },
    disableClose : true
  });
  dialogRef.afterClosed().subscribe(result=>{
    console.log(result);
    if(result){ 
      let data = {
        hashId: rowvalue.hashId,
        status: 0
      }
      this.loaderservice.showLoader = true
      this._apiService.updateBusinessDocsStatus(data)
    }
  })
  
}

viewDetails(rowvalue:any){
  this.dialog.open(ViewDocumentsDetailsComponent, {
    width: '400px',
    data: {
      title: 'Document Details',
      ref: this.dialog,
      data: rowvalue
    },
  });
}


openvideo(){
  this.dialog.open(YoutubeEmbedVideoComponent,{
  width:'1000px',
  disableClose:true,
  data:{
    link:"",
    title: 'Business profile'
  }})
  }

  opencontact(){
    this.router.navigate(['/contact-us']);
  }


downloadDoc(url:any){
window.open(url)
}
}
